import {
  maxWidthContainer,
  maxWidthContainerWithoutGutters,
  minBreakpoints,
  theme,
} from '@noths/polaris-client-ribbons-base';
import { mediaQuery } from '@noths/polaris-client-styles';
import { themeVariables } from '@noths/polaris-design-system-abstract-theme';
import { css } from 'styled-components';

import { grid } from 'src/styles/pages.styles';

const { spacing } = theme;
const { spacing: themeSpacing } = themeVariables;

export const listingsLayoutRoot = css`
  ${maxWidthContainerWithoutGutters};

  ${mediaQuery(
    { min: minBreakpoints.M },
    css`
      ${maxWidthContainer};

      /* The page's own side gutters start here, so the product grid inside stops
         supplying its own. Declared next to the gutters it answers to, so the two
         cannot drift apart. */
      --productGridPaddingInline: 0;
    `,
  )};
`;

export const listingLayoutGrid = css`
  ${mediaQuery(
    { min: minBreakpoints.L },
    css`
      ${grid};
      padding-top: ${spacing.xl}px;
    `,
  )};
`;

export const listingsLayoutProducts = css`
  /* The query container for the product grid inside, which steps its column count on
     the width this column is given rather than on the viewport. Declared outside the
     media query because the grid needs a container at every width. */
  container-type: inline-size;

  /* Keeps the products column's own layering to itself, so it scrolls under the
     sticky listings header rather than over it.

     ProductCard paints its image area at z-index 2 on a card that is only
     position: relative, so that value escapes the card and competes with the page.
     The header is also z-index 2 and comes earlier in the DOM, so it lost.

     container-type is documented as applying layout containment, which should form a
     stacking context on its own, but Chrome does not contain the value in practice.
     Verified in the browser: without this the card's image paints over the header. */
  isolation: isolate;

  ${mediaQuery(
    { min: minBreakpoints.L },
    css`
      grid-column: 4 / span 9;
      order: 2;

      /* How far apart the product grid spaces its cards. Widened here, and only here,
         because it follows the sidebar appearing (see listingsLayoutSidebar) and only
         the layout knows about that: the products column is *narrower* once the sidebar
         takes its quarter, so no container query the grid could ask would tell it apart
         from a tablet. Keep this in step with that breakpoint. Everywhere else the grid
         falls back to its own default, which keeps it layout-agnostic. */
      --productGridGap: var(${themeSpacing.md});
    `,
  )}
`;

export const listingsLayoutSidebar = css`
  display: none;

  ${mediaQuery(
    { min: minBreakpoints.L },
    css`
      display: block;
      grid-column: 1 / span 3;
      order: 1;
    `,
  )}
`;

export const listingsLayoutFooter = css`
  ${mediaQuery(
    { min: minBreakpoints.L },
    css`
      grid-column: 4 / span 9;
      order: 2;
    `,
  )}
`;
